<div class="local-map">
    <div class="local-map__layers">
        <div class="local-map__selector"></div>
    </div>

    <div class="local-map-info info-panel ui__panel ui__panel--floating">


    </div>
</div>